import React, { useState, useEffect } from "react";
import "./contact.css";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const ContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    plan: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out", once: false });
    AOS.refresh();
  }, []);


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await emailjs.send(
      SERVICE_ID,   
      TEMPLATE_ID,   
      {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        plan: formData.plan,
        message: formData.message,
      },
      PUBLIC_KEY    
    );

    alert("Email enviado com sucesso!");

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      plan: "",
      message: "",
    });
  } catch (error) {
    console.error("Erro ao enviar:", error);
    alert("Erro ao enviar email. Tente novamente mais tarde.");
  }
};
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contacts" className="contact-section">
      <div className="contact-container" data-aos="fade-up">

        {/* Header */}
        <div className="contact-header">
          <p className="contact-label">Contacta-nos</p>
          <h1 className="contact-title">
            Pronto{" "}<span className="para-comecar-title">para começar?</span>
          </h1>
          <p className="contact-description">
            Fala-nos um pouco sobre o teu alojamento e os teus objetivos.
            <br />
            A nossa equipa entrará em contacto contigo em breve com
            <br />
            uma proposta personalizada — sem compromisso.
          </p>
        </div>

        {/* Form — no white card, fields float on yellow */}
        <form className="contact-form" onSubmit={handleSubmit}>

          {/* Row 1: Nome + Apelido */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nome</label>
              <input
                type="text"
                name="firstName"
                placeholder="Primeiro Nome"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Apelido</label>
              <input
                type="text"
                name="lastName"
                placeholder="Último Nome"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          </div>

          {/* Row 2: Email + Telemóvel */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">E-mail</label>
              <input
                type="email"
                name="email"
                placeholder="exemplo@gmail.com"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Telemóvel</label>
              <input
                type="tel"
                name="phone"
                placeholder="(+351) 000 000 000"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>

          {/* Row 3: Plano — full width */}
          <div className="form-row">
            <div className="form-group form-group--full">
              <label className="form-label">Plano</label>
              <div className="select-wrapper">
               <select
                  name="plan"
                  value={formData.plan}
                  onChange={handleChange}
                  required
                  className="form-input form-select"
                >
                  <option value="" disabled hidden>
                    Selecione um dos planos...
                  </option>
                  <option value="Gestão Online">Gestão Online</option>
                  <option value="Gestão Completa">Gestão Completa</option>
                  <option value="Plano Adicional">Plano Adicional</option>
                </select>
                <span className="select-arrow">↓</span>
              </div>
            </div>
          </div>

          {/* Row 4: Mensagem — full width */}
          <div className="form-row">
            <div className="form-group form-group--full">
              <label className="form-label">Mensagem</label>
              <textarea
                name="message"
                placeholder="Diga-nos como podemos ajudar..."
                value={formData.message}
                onChange={handleChange}
                className="form-input form-textarea"
              />
            </div>
          </div>

          {/* Submit */}
          <button type="submit" className="submit-btn">
            SUBMETER PEDIDO DE REUNIÃO
          </button>

        </form>
      </div>
    </section>
  );
};

export default ContactSection;